export default __webpack_public_path__ + "static/media/giftIcon.e3894303.svg";